export default __webpack_public_path__ + "images/X5.642523e.png";